import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
} from "@mui/material";
import { statusStyleArray } from "../../config";
import {
  formattedAmountWithoutAed,
  getImageSrc,
} from "../../../../utils/CommonFunction";
import { ReactComponent as NewRenovationIcon } from "../../../../assets/svg/NewRenovationIcon.svg";
import { ReactComponent as RightArrowIcon } from "../../../../assets/svg/RightArrowIcon.svg";
import styles from "../../styles";
import { useNavigate, useParams } from "react-router-dom";
import MilestoneModal from "../../../../components/MilestoneModal";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
}));

export default function Inclusions({ details, getProjectDetails }) {
  const [selectedMilestone, setSelectedMilestone] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleClick = (item) => {
    console.log("item", item, id);

    navigate(`/package/details/${id}/inclusion/${item.id}`, {
      state: { inclusionData: item, project: details },
    });
  };

  const handleCloseModal = () => setSelectedMilestone(null);

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflow: "none !important",
          boxShadow: "none",
          maxHeight: "87vh",
          marginTop: "2vh",
        }}
      >
        <Table
          sx={{
            "& thead": {
              "& th": {
                color: "#949DAA",
                fontWeight: "500",
              },
            },
            "& tbody": {
              "& tr:hover": {
                backgroundColor: "#f7f7f7",
              },
              "& tr": {
                borderBottom: "none",
              },
            },
          }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Item</StyledTableCell>
              <StyledTableCell>Material</StyledTableCell>
              <StyledTableCell>Units</StyledTableCell>
              {details?.isGroup && (
                <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                  <strong
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    Cost ({renderCurrencyIcon('small')})
                  </strong>
                </StyledTableCell>
              )}
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {details?.inclusions?.map((item, idx) => (
              <>
                <TableRow key={item.id}>
                  <StyledTableCell>
                    <Box display="flex" alignItems="center">
                      <Box
                        component="img"
                        src={getImageSrc(item?.image?.path)}
                        alt="Inclusion Icon"
                        sx={{
                          width: 45,
                          height: 45,
                          borderRadius: "8px",
                          border: "2px solid white",
                          boxShadow: "0px 4px 2.67px 0px #00000026",
                          marginRight: 1,
                        }}
                      />
                      <span>{item?.name}</span>
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Box display="flex" alignItems="center" gap="5px">
                      <Box display="flex" alignItems="center">
                        <NewRenovationIcon />
                      </Box>
                      <Box color="#949DAA">{item?.materialType}</Box>
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell>{item?.materialUnit}</StyledTableCell>
                  {details?.isGroup && (
                    <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                      {item?.cost
                        ? `${formattedAmountWithoutAed(item?.cost)}`
                        : "-"}
                    </StyledTableCell>
                  )}
                  <StyledTableCell>
                    <div style={styles.statusContainer}>
                      <div
                        style={{
                          ...styles.milestoneStatusCircle,
                          backgroundColor:
                            statusStyleArray.find(
                              (style) => style.status === item?.status
                            )?.backgroundColor || "#FFAD5C",
                        }}
                      ></div>
                      <div style={styles.statusText}>
                        {getStatusDisplayText(item?.status)}
                      </div>
                    </div>
                    {/* <div
                      style={{
                        ...styles.status_pill,
                        backgroundColor:
                          statusStyleArray.find(
                            (style) => style.status === item?.status
                          )?.backgroundColor || "transparent",
                        color:
                          statusStyleArray.find(
                            (style) => style.status === item?.status
                          )?.color || "black",
                      }}
                    >
                      {getStatusDisplayText(item?.status)}
                    </div> */}
                  </StyledTableCell>
                  <StyledTableCell>
                    <RightArrowIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => handleClick(item)}
                    />
                  </StyledTableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {selectedMilestone && (
        <MilestoneModal
          isCreationOpen={Boolean(selectedMilestone)}
          visible={Boolean(selectedMilestone)}
          handleCloseCreation={handleCloseModal}
          selectedMilestone={selectedMilestone}
          isEdit={Object.keys(selectedMilestone).length !== 0}
          milestones={details?.milestone}
          proposalId={id}
          getProjectDetails={getProjectDetails}
        />
      )}{" "}
    </>
  );
}
